import atoms from './atoms';
import molecules from './molecules';
import organisms from './organisms';

export default Object.assign(atoms, molecules, organisms);
